import { useContext, useEffect, useState } from 'react';
import { HttpContext } from '../../HttpContext';

export function useBuildingService(id) {
  const { httpClient } = useContext(HttpContext);
  const [buildings, setBuildings] = useState([])

  useEffect(() => {
    getBuildings().then(data => setBuildings(data.Data))
  }, [id])

  const getBuildings = async () => {
    return httpClient.get("/complex").then(promise => promise.data)
  }

  const updateBuilding = async (body) => {
    return httpClient.put("/complex", body).then(promise => promise.data)
  }

  const createBuilding = async (body) => {
    return httpClient.post("/complex", body).then(promise => promise.data)
  }

  const getBuilding = async () => {
    return httpClient.get(`/complex/${id}`).then(promise => promise.data)
  }

  const createHouse = async (body) => {
    return httpClient.post("/complex/house", body).then(promise => promise.data)
  }

  const deleteHouse = async (houseId) => {
    return httpClient.delete(`/complex/house/${houseId}`).then(promise => promise.data)
  }

  return {getBuildings, updateBuilding, createBuilding, getBuilding ,createHouse, deleteHouse, buildings}
}
